module.exports = __webpack_public_path__ + "static/iso-27001-38e72917e19b0ef8a280937cce903ae5.png";